import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

export type Favorite = {
  affiliateId?: string
  occupationType?: number
  withoutWallet?: 'true'
  data?: string
  name: string
  id?: string
}

interface NavigationState {
  favorites: Favorite[]
  isLocked: boolean
  visoesMenuIsOpen: boolean
  favMenuIsOpen: boolean
  recentChatMenuIsOpen: boolean
  toggleIsLocked: () => void
  toggleVisoesIsOpen: () => void
  toggleFavIsOpen: () => void
  toggleRecentChatIsOpen: () => void
  addFavorite: (item: Favorite) => void
  updateFavoriteItem: (item: Favorite) => void
  removeFavorite: (url: string) => void
  resetFavorites: () => void
  isHydrated: boolean
}

const initialState = {
  favorites: [],
  isLocked: false,
  visoesMenuIsOpen: false,
  favMenuIsOpen: false,
  recentChatMenuIsOpen: false,
}

export const useSideBarStore = create<
  NavigationState,
  [['zustand/persist', unknown]]
>(
  persist<NavigationState>(
    (set) => ({
      ...initialState,
      isHydrated: false,
      toggleIsLocked: () => {
        set((state) => {
          return { isLocked: !state.isLocked }
        })
      },
      toggleVisoesIsOpen: () => {
        set((state) => {
          return { visoesMenuIsOpen: !state.visoesMenuIsOpen }
        })
      },
      toggleFavIsOpen: () => {
        set((state) => {
          return { favMenuIsOpen: !state.favMenuIsOpen }
        })
      },
      toggleRecentChatIsOpen: () => {
        set((state) => {
          return { recentChatMenuIsOpen: !state.recentChatMenuIsOpen }
        })
      },
      addFavorite: (item: Favorite) => {
        set((state) => {
          const itemExists = state.favorites.some((favorite) => {
            return favorite.data === item.data || favorite.name === item.name
          })

          if (itemExists) return state

          return {
            favorites: [...state.favorites, item],
          }
        })
      },
      updateFavoriteItem: (item: Favorite) => {
        set((state) => {
          const itemIndex = state.favorites.findIndex(
            (favorite) => favorite.data === item.data,
          )

          if (itemIndex === -1) return state

          state.favorites[itemIndex] = item

          return {
            favorites: state.favorites,
          }
        })
      },
      removeFavorite: (url: string) => {
        set((state) => {
          return {
            favorites: state.favorites.filter((item) => item.data !== url),
          }
        })
      },
      resetFavorites: () => {
        set(() => {
          return {
            favorites: [],
          }
        })
      },
    }),
    {
      name: '@cockpitia-sidebar',
      storage: createJSONStorage(() => sessionStorage),
      onRehydrateStorage: () => (state) => {
        if (state) {
          state.isHydrated = true
        }
      },
    },
  ),
)
